<template>
  <div>
    <el-form ref="formRef" label-width="190px">
      <el-row style="margin-bottom: 20px">
        <el-col :span="24"><b>指标选择(Indicator selection)</b></el-col>
      </el-row>
      <el-row>
        <el-col :span="24">
          <el-form-item label="日期(Date)">
            <el-radio-group v-model="timeDimension" @change="handleTimeChange">
              <el-radio v-for="it in dateIndicator" :label="it.value" :key="it.value">{{ it.name }}</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item label="流量漏斗(Traffic Funnel)">
            <el-checkbox-group v-model="traffic" @change="handleChange('traffic')">
              <el-checkbox v-for="it in trafficIndicator" :label="it.value" :key="it.value">{{ it.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
          <el-form-item label="收入指标(Income Indicator)">
            <el-checkbox-group v-model="income" @change="handleChange('income')">
              <el-checkbox v-for="it in incomeIndicator" :label="it.value" :key="it.value">{{ it.name }}</el-checkbox>
            </el-checkbox-group>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div id="chart" :style="{height: height + 'px'}"/>
  </div>
</template>

<script>
import echarts from 'echarts'
import 'echarts/theme/macarons.js'
import wonderlandTheme from './js/wonderland'
import option from './js/option'

export default {
  props: {
    value: Object,
    chartData: Array,
    height: Number
  },
  data: function () {
    return {
      chart: null,
      dateIndicator: [{
        value: 1,
        name: '日(Day)'
      }],
      trafficIndicator: [{
        value: 'imp_ad_cnt',
        name: '广告请求量(Request Count)'
      }, {
        value: 'bid_ad_cnt',
        name: '广告返回量(Return Count)'
      }, {
        value: 'ad_delivery_ratio',
        name: '填充率(Fill Rate)'
      }, {
        value: 'charged_impression_cnt',
        name: '曝光量(Exposure Count)'
      }, {
        value: 'imp_ratio',
        name: '曝光率(Exposure Through Rate)'
      }, {
        value: 'charged_click_cnt',
        name: '点击量(Click Count)'
      }, {
        value: 'click_ratio',
        name: '点击率(Click Through Rate)'
      }],
      incomeIndicator: [{
        value: 'cost_estimate',
        name: '收入(Income)'
      },{
        value: 'cost_estimate_ecpm',
        name: 'eCPM'
      }]
    }
  },
  computed: {
    timeDimension: {
      get() {
        const v = this.value?.timeDimension
        // 移除小时维度后，历史值(4)统一降级为按天(1)
        return v === 4 ? 1 : (v || 1)
      },
      set(val) {
        this.$emit('input', {...this.value, timeDimension: val})
      }
    },
    traffic: {
      get() {
        return this.value.traffic || []
      },
      set(val) {
        this.$emit('input', {...this.value, traffic: val})
      }
    },
    income: {
      get() {
        return this.value.income || []
      },
      set(val) {
        this.$emit('input', {...this.value, income: val})
      }
    },
    chartOption: function () {
      let o = {...option};
      const yValues = [...this.traffic, ...this.income]
      const name1 = [...this.trafficIndicator, ...this.incomeIndicator].find(item => item.value === yValues[0])?.name
      const name2 = [...this.trafficIndicator, ...this.incomeIndicator].find(item => item.value === yValues[1])?.name
      // 判断是否为百分比字段
      const isPercentageField = (field) => ['imp_ratio', 'click_ratio', 'ad_delivery_ratio'].includes(field)
      // 生成legend
      o.legend.data = [name1, name2]
      // 配置全局tooltip
      o.tooltip = {
        trigger: 'axis',
        formatter: function(params) {
          let result = params[0].axisValueLabel + '<br/>'
          params.forEach(function(item) {
            if (item.value !== null && item.value !== undefined && !isNaN(item.value)) {
              const field = item.seriesName === name1 ? yValues[0] : yValues[1]
              const value = isPercentageField(field) ? (item.value * 100).toFixed(2) + '%' : item.value
              result += item.marker + item.seriesName + ': ' + value + '<br/>'
            }
          });
          return result
        }
      }
      // 生成series
      o.series = []
      o.series.push({
        name: name1,
        type: 'bar',
        data: this.chartData.map(item => {
          const num = Number(item[yValues[0]]);
          return Number.isInteger(num) ? num : Number(num);
        })
      })
      o.series.push({
        name: name2,
        type: 'line',
        yAxisIndex: 1,
        data: this.chartData.map(item => {
          const num = Number(item[yValues[1]]);
          return Number.isInteger(num) ? num : Number(num);
        })
      })
      // 生成xAxis
      o.xAxis[0].data = this.chartData.map(item => item.dt)
      // 生成yAxis
      o.yAxis = []
      o.yAxis.push({
        type: 'value',
        name: name1,
        axisLabel: {
          formatter: function(value) {
            return isPercentageField(yValues[0]) ? (value * 100).toFixed(2) + '%' : value
          }
        }
      })
      o.yAxis.push({
        type: 'value',
        name: name2,
        // 添加y轴标签格式化
        axisLabel: {
          formatter: function(value) {
            return isPercentageField(yValues[1]) ? (value * 100).toFixed(2) + '%' : value
          }
        }
      })
      return o;
    }
  },
  mounted: function () {
    wonderlandTheme(echarts);
    this.chart = echarts.init(document.getElementById('chart'), 'wonderland');
    window.addEventListener('resize', this.chart.resize);
  },
  destroyed: function () {
    window.removeEventListener('resize', this.chart.resize);
  },
  watch: {
    chartData: {
      immediate: true,
      handler: 'updateChart'
    }
  },
  methods: {
    handleTimeChange: function () {
      this.$emit('change')
    },
    updateChart() {
      if (!this.chart) return
      this.chart.clear()
      if (!this.chartData || this.chartData.length === 0) {
        this.chart.showLoading({
          text: '暂无数据(No Data)',
          color: '#ffffff',
          textColor: '#8a8e91',
          fontsize: 20,
          maskColor: 'rgba(255, 255, 255, 0.8)'
        })
        return
      } else {
        this.chart.hideLoading()
      }
      this.chart.setOption(this.chartOption)
    },
    handleChange(type) {
      const total = this.traffic.length + this.income.length
      if (total > 2) {
        // 引用当前类别和另一类别
        const current = type === 'traffic' ? this.traffic : this.income
        const other = type === 'traffic' ? this.income : this.traffic
        // 当前类别有超过1个就移除第一个，否则移除另一类别第一个
        if (current.length > 1) {
          current.shift()
        } else if (other.length > 0) {
          other.shift()
        }
      }
      this.$emit('change')
      this.updateChart()
    },
    clear: function () {
      this.chart.clear();
    }
  },
}
</script>
